var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 13 18.5 20 12 20C5.5 20 2 13 2 12C2 11 5.5 4 12 4C18.5 4 22 11 22 12ZM20.0227 11.754C20.0228 11.7539 20.0224 11.7556 20.0215 11.7589L20.0227 11.754ZM19.5912 11.2774C19.7493 11.5707 19.8627 11.8167 19.9364 12C19.8627 12.1833 19.7493 12.4293 19.5912 12.7226C19.2294 13.3936 18.6781 14.2291 17.9509 15.0371C16.4799 16.6715 14.4783 18 12 18C9.52168 18 7.52011 16.6715 6.04909 15.0371C5.32191 14.2291 4.77061 13.3936 4.40883 12.7226C4.25066 12.4293 4.13727 12.1833 4.06365 12C4.13727 11.8167 4.25066 11.5707 4.40883 11.2774C4.77061 10.6064 5.32191 9.7709 6.04909 8.96293C7.52011 7.32846 9.52168 6 12 6C14.4783 6 16.4799 7.32846 17.9509 8.96293C18.6781 9.7709 19.2294 10.6064 19.5912 11.2774ZM3.97726 11.754L3.97846 11.7589C3.97759 11.7556 3.97722 11.7539 3.97726 11.754ZM3.97726 12.246C3.97712 12.2467 3.97724 12.246 3.97726 12.246L3.97846 12.2411C3.97797 12.243 3.97745 12.2452 3.97726 12.246ZM20.0215 12.2411C20.0224 12.2444 20.0228 12.2461 20.0227 12.246L20.0215 12.2411Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.756870311d25450113045c85cc905996.svg";
export { ForwardRef as ReactComponent };